// Підписи для плану розселення і аналізу фонду: коди DSS/ядра -> українською.

export const GENDER_LABELS = {
  male: "чоловічий",
  female: "жіночий",
  empty: "порожній",
  // У блоці є мешканці без статі -- стать блоку визначити не можна.
  unknown: "невідома",
};

// Стать мешканця/студента (а не блоку).
export const PERSON_GENDER_LABELS = {
  male: "чоловіча",
  female: "жіноча",
};

export const SOFT_VIOLATION_LABELS = {
  course_mix: "порушено м'яке обмеження (курс)",
};

// Причини, з яких здобувач лишився без місця (unplaced).
export const UNPLACED_REASONS = {
  no_room_for_gender: "немає блоку для цієї статі",
  no_free_beds: "немає вільних місць у підходящих блоках",
  no_accessible_room: "немає доступної кімнати",
};

// Причини, з яких здобувач не потрапив у розрахунок (skipped.applicants).
export const SKIPPED_APPLICANT_REASONS = {
  zone_missing: "не вказано віддаленість",
  gender_missing: "не вказано стать",
  course_missing: "не вказано курс",
  current_room_unavailable: "поточна кімната недоступна для розрахунку",
};

// Причини, з яких кімнату не враховано (skipped.rooms).
export const SKIPPED_ROOM_REASONS = {
  room_number_invalid: "номер кімнати не у форматі «блок/тип»",
  occupant_data_missing: "у мешканця немає статі чи курсу",
};

export const unplacedReason = (reason) => (reason ? UNPLACED_REASONS[reason] || reason : "—");

export const softViolationLabels = (codes) =>
  (codes || []).map((code) => SOFT_VIOLATION_LABELS[code] || code);

// [{ id, reason }] -> [{ reason, label, count }] за спаданням кількості.
export function groupSkipped(items, labels) {
  const counts = new Map();
  (items || []).forEach((item) => counts.set(item.reason, (counts.get(item.reason) || 0) + 1));
  return [...counts.entries()]
    .map(([reason, count]) => ({ reason, label: labels[reason] || reason, count }))
    .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label, "uk"));
}
